export default "__VITE_ASSET__DDt4BooP__"